import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=7fe9ee54"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe9ee54')) {
      api.createRecord('7fe9ee54', component.options)
    } else {
      api.reload('7fe9ee54', component.options)
    }
    module.hot.accept("./UserCard.vue?vue&type=template&id=7fe9ee54", function () {
      api.rerender('7fe9ee54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Pages/UserProfile/UserCard.vue"
export default component.exports